module.exports = __webpack_public_path__ + "img/transport_taxi.1c45f91.png";